<template>
    <main-content v-if="$can('manage', 'gateway')" with_go_back_bar>
        <corporate-form :submit="addCorporate" :form_data="corporate"></corporate-form>
    </main-content>
</template>

<script>

import mainContent from '@/components/main-content'
import corporateForm from './components/corporate-form'
import $ from "jquery";
import {billService} from '@/common/api.service'
import {KTApp} from '@/plugins/core/app';
import {KTUtil} from '@/plugins/core/util'


export default { //todo
    components: {
        mainContent, corporateForm
    },
    data() {
        return {
            corporate: {},
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
        }
    },
    methods: {
        addCorporate(form, btn) {
            KTApp.progress(btn)
            billService.addCorporate(this.corporate).then(response => {
                this.$router.push('/bill')
            }).catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data);
                }
                return this.showMsg(form, 'danger',response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        }
    }
}
</script>

<style>

</style>